module.exports = __webpack_public_path__ + "static/media/clear-button.73f030ea.svg";